import http from 'plugins/axios';

export default {
  getUrlList({page,size,pair}){
return http.get({
  url:`/la/admin/control/price/list?page=${page}&size=${size}&pair=${pair}`
})
  },
 //获取交易对
 getPairList(){
  return http.get({
    url:'/la/admin/symbol/list'
  })
},

  delOne(id) {
    return http.post({
      url: `/la/admin/app/line/url/del?id=${id}`,
    });
  },
  addOne(data) {
    return http.post({
      url: '/la/admin/control/price/save',
      data,
    });
  },
  updateUrl(data) {
    return http.post({
      url: '/la/admin/control/price/change',
      data,
    });
  },
  // updateCode(data) {
  //   return http.post({
  //     url: '/la/admin/countryCode/update',
  //     data,
  //   });
  // },
};
